import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { api } from "@/lib/api";
import { User } from "@/lib/types";

interface AuthCtx { user: User | null | false; login: (email: string, password: string) => Promise<User>; logout: () => Promise<void>; refresh: () => Promise<void> }
const Ctx = createContext<AuthCtx>(null as any);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null | false>(null);

  const refresh = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  useEffect(() => { refresh(); }, []);

  const login = async (email: string, password: string) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("sl_token", data.access_token);
    setUser(data.user);
    return data.user as User;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("sl_token");
    setUser(false);
  };
  return <Ctx.Provider value={{ user, login, logout, refresh }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
